// client/src/coms/views/VoiceView.js
import React from 'react';
import ChatView from './ChatView';
import VoiceWatchBanner from './games_parts/VoiceWatchBanner';

const VOICE_MESSAGE_TTL_MINUTES = 15;

export default function VoiceView({ server, channel, user }) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0, width: '100%' }}>
      <VoiceWatchBanner server={server} channel={channel} />
      <div style={{ flex: '1 1 auto', minHeight: 0, minWidth: 0, display: 'flex' }}>
        <ChatView
          server={server}
          channel={channel}
          user={user}
          messageChannelKind="voice"
          messageTtlMinutes={VOICE_MESSAGE_TTL_MINUTES}
        />
      </div>
    </div>
  );
}
